import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, withCtx as _withCtx, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87e8897c")

_pushScopeId("data-v-87e8897c")
const _hoisted_1 = {
  key: 0,
  class: "row client-data-switcher"
}
const _hoisted_2 = { class: "ignore-padding" }
const _hoisted_3 = { class: "ignore-padding" }
const _hoisted_4 = { class: "ignore-padding" }
const _hoisted_5 = { class: "ignore-padding" }
const _hoisted_6 = { class: "ignore-padding" }
const _hoisted_7 = {
  key: 1,
  class: "businessClients-container-template"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 col-md-6 ignore-padding businessClient-name-row" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-10 title-wrapper ignore-padding" }
const _hoisted_12 = { class: "field-title" }
const _hoisted_13 = {
  key: 0,
  class: "col-2 pop-up-button ignore-padding"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "field-value" }
const _hoisted_17 = { class: "field-title" }
const _hoisted_18 = { class: "field-value" }
const _hoisted_19 = { class: "field-title t-align-end" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_22 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_25 = { class: "field-title" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "field-value" }
const _hoisted_29 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_30 = { class: "field-title" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "field-value" }
const _hoisted_34 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_35 = { class: "field-title" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "field-value" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_41 = { class: "field-title" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "field-value" }
const _hoisted_45 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_46 = { class: "field-title" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "field-value" }
const _hoisted_50 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_51 = { class: "field-title" }
const _hoisted_52 = {
  key: 0,
  class: "p-relative"
}
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "field-value" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_57 = { class: "field-title" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "field-value" }
const _hoisted_61 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_62 = { class: "field-title" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { class: "field-value" }
const _hoisted_66 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_67 = { class: "field-title" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "field-value" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_73 = { class: "field-title" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { class: "field-value" }
const _hoisted_77 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_78 = { class: "field-title" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "field-value" }
const _hoisted_82 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_83 = { class: "field-title" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  key: 1,
  style: {"overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_86 = { class: "field-value" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-12 col-md-6" }
const _hoisted_89 = {
  key: 0,
  class: "contact-receive-email"
}
const _hoisted_90 = { class: "field-title" }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { class: "field-title" }
const _hoisted_93 = { class: "field-value" }
const _hoisted_94 = {
  key: 0,
  class: "row d-flex d-md-none"
}
const _hoisted_95 = { class: "col-12 col-md-4 businessClient-mobile-details-item" }
const _hoisted_96 = { class: "field-title" }
const _hoisted_97 = {
  key: 0,
  class: "product-text active text-uppercase"
}
const _hoisted_98 = {
  key: 1,
  class: "product-text not-active text-uppercase"
}
const _hoisted_99 = {
  key: 1,
  class: "page-delimiter"
}
const _hoisted_100 = {
  key: 2,
  class: "col-12 text-c pt-3"
}
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_102 = { class: "row p-relative" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = { class: "col-12 col-md-6" }
const _hoisted_105 = { class: "field-title" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = {
  key: 0,
  class: "invalid-contact-duplicates"
}
const _hoisted_108 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_109 = { key: 1 }
const _hoisted_110 = { class: "field-value" }
const _hoisted_111 = { class: "col-12 col-md-6" }
const _hoisted_112 = { class: "field-title" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = {
  key: 0,
  class: "invalid-contact-duplicates"
}
const _hoisted_115 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { class: "field-value" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-12 col-md-6" }
const _hoisted_120 = { class: "field-title" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 0,
  class: "invalid-contact-duplicates"
}
const _hoisted_123 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { class: "field-value" }
const _hoisted_126 = { class: "col-12 col-md-6" }
const _hoisted_127 = { class: "field-title" }
const _hoisted_128 = { key: 0 }
const _hoisted_129 = {
  key: 0,
  class: "invalid-contact-duplicates"
}
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_131 = { key: 1 }
const _hoisted_132 = { class: "field-value" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "col-12 col-md-6" }
const _hoisted_135 = { class: "field-title" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = {
  key: 0,
  class: "invalid-contact-duplicates"
}
const _hoisted_138 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { class: "field-value" }
const _hoisted_141 = { class: "col-12 col-md-6" }
const _hoisted_142 = { class: "field-title" }
const _hoisted_143 = { key: 0 }
const _hoisted_144 = {
  key: 1,
  class: "single-ellipsis"
}
const _hoisted_145 = { class: "field-value" }
const _hoisted_146 = { class: "row" }
const _hoisted_147 = { class: "col-12 col-md-6" }
const _hoisted_148 = {
  key: 0,
  class: "contact-receive-email"
}
const _hoisted_149 = { class: "field-title" }
const _hoisted_150 = { key: 1 }
const _hoisted_151 = { class: "field-title" }
const _hoisted_152 = {
  key: 3,
  class: "card collapsed"
}
const _hoisted_153 = {
  class: "card-header collapsed",
  id: "headingbusinessClientDiscountCombination",
  "data-toggle": "collapse",
  "data-target": "#businessClientDiscountCombination"
}
const _hoisted_154 = { class: "mb-0" }
const _hoisted_155 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "businessClientDiscountCombination"
}
const _hoisted_156 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_157 = {
  id: "businessClientDiscountCombination",
  class: "collapse",
  "aria-labelledby": "headingbusinessClientDiscountCombination",
  "data-parent": "#accordionExample"
}
const _hoisted_158 = { class: "card-body" }
const _hoisted_159 = {
  class: "several-section",
  style: {"position":"relative"}
}
const _hoisted_160 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_161 = {
  key: 0,
  class: "d-flex justify-content-end p-relative"
}
const _hoisted_162 = { class: "row combination-row" }
const _hoisted_163 = { class: "col-6 col-md-4" }
const _hoisted_164 = { class: "field-title" }
const _hoisted_165 = { key: 0 }
const _hoisted_166 = { key: 1 }
const _hoisted_167 = { class: "field-value" }
const _hoisted_168 = { class: "col-6 col-md-4" }
const _hoisted_169 = { class: "field-title" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { class: "field-value" }
const _hoisted_173 = { class: "col-6 col-md-2" }
const _hoisted_174 = { class: "field-title" }
const _hoisted_175 = { key: 0 }
const _hoisted_176 = { key: 1 }
const _hoisted_177 = { class: "field-value" }
const _hoisted_178 = { class: "col-6 col-md-2" }
const _hoisted_179 = { class: "field-title" }
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { key: 1 }
const _hoisted_182 = { class: "field-value" }
const _hoisted_183 = {
  key: 1,
  class: "row combination-delimiter"
}
const _hoisted_184 = {
  key: 4,
  class: "card collapsed"
}
const _hoisted_185 = {
  class: "card-header collapsed",
  id: "headingbusinessClientOrdersSettings",
  "data-toggle": "collapse",
  "data-target": "#businessClientOrdersSettings"
}
const _hoisted_186 = { class: "mb-0" }
const _hoisted_187 = {
  class: "btn btn-link collapsed",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "businessClientOrdersSettings"
}
const _hoisted_188 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_189 = {
  id: "businessClientOrdersSettings",
  class: "collapse",
  "aria-labelledby": "headingbusinessClientOrdersSettings",
  "data-parent": "#accordionExample"
}
const _hoisted_190 = { class: "card-body" }
const _hoisted_191 = {
  class: "several-section",
  style: {"position":"relative"}
}
const _hoisted_192 = { class: "row" }
const _hoisted_193 = { class: "field-title" }
const _hoisted_194 = { key: 0 }
const _hoisted_195 = { key: 1 }
const _hoisted_196 = { class: "field-value" }
const _hoisted_197 = { class: "col-12 col-md-6" }
const _hoisted_198 = { class: "field-title" }
const _hoisted_199 = { key: 0 }
const _hoisted_200 = { key: 1 }
const _hoisted_201 = { class: "field-value" }
const _hoisted_202 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_203 = { class: "field-title" }
const _hoisted_204 = { class: "p-relative" }
const _hoisted_205 = { class: "col-12 col-md-6" }
const _hoisted_206 = { class: "field-title" }
const _hoisted_207 = { key: 0 }
const _hoisted_208 = { key: 1 }
const _hoisted_209 = { class: "field-value" }
const _hoisted_210 = { class: "col-12 col-md-6" }
const _hoisted_211 = { class: "field-title" }
const _hoisted_212 = { key: 0 }
const _hoisted_213 = { key: 1 }
const _hoisted_214 = { class: "field-value" }
const _hoisted_215 = { class: "col-12 col-md-6" }
const _hoisted_216 = { class: "field-title" }
const _hoisted_217 = { key: 0 }
const _hoisted_218 = {
  key: 1,
  class: "truncate"
}
const _hoisted_219 = { class: "field-value" }
const _hoisted_220 = { class: "col-12" }
const _hoisted_221 = { class: "field-title" }
const _hoisted_222 = { key: 0 }
const _hoisted_223 = { class: "input-text-length" }
const _hoisted_224 = /*#__PURE__*/_createTextVNode("/1000 ")
const _hoisted_225 = { key: 1 }
const _hoisted_226 = { class: "field-value" }
const _hoisted_227 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_228 = { class: "row" }
const _hoisted_229 = { class: "col-10 field-title" }
const _hoisted_230 = {
  key: 0,
  class: "col-2"
}
const _hoisted_231 = { class: "photo-edit-section" }
const _hoisted_232 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_233 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_234 = {
  key: 1,
  class: "row"
}
const _hoisted_235 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_236 = { class: "row" }
const _hoisted_237 = { class: "col-lg-6 col-12" }
const _hoisted_238 = { class: "col-lg-6 col-12" }
const _hoisted_239 = {
  key: 0,
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_240 = { class: "col-12 ignore-padding" }
const _hoisted_241 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_242 = { class: "photo-wrapper photoInstruction-wrapper" }
const _hoisted_243 = {
  key: 0,
  style: {"top":"0!important"},
  class: "dark-squared"
}
const _hoisted_244 = {
  class: "several-section",
  style: {"z-index":"1"}
}
const _hoisted_245 = {
  key: 0,
  class: "row"
}
const _hoisted_246 = { class: "col-10" }
const _hoisted_247 = { class: "field-title" }
const _hoisted_248 = {
  key: 0,
  class: "col-2"
}
const _hoisted_249 = { class: "photo-edit-section" }
const _hoisted_250 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_251 = {
  key: 0,
  class: "cropper-wrapper d-flex"
}
const _hoisted_252 = {
  key: 1,
  class: "row"
}
const _hoisted_253 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_254 = { class: "row" }
const _hoisted_255 = { class: "col-lg-6 col-12" }
const _hoisted_256 = { class: "col-lg-6 col-12" }
const _hoisted_257 = {
  key: 1,
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_258 = { class: "col-10" }
const _hoisted_259 = { class: "field-title" }
const _hoisted_260 = { class: "col-11 ignore-padding" }
const _hoisted_261 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_262 = { class: "col-4 col-md-3 photo-container" }
const _hoisted_263 = { class: "photo-wrapper companyLogo-wrapper" }
const _hoisted_264 = {
  key: 0,
  class: "col-1"
}
const _hoisted_265 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-pencil-edit fs-16",
  "data-v-099e29f6": ""
}, null, -1)
const _hoisted_266 = {
  key: 2,
  class: "businessClients-container-template"
}
const _hoisted_267 = { class: "row" }
const _hoisted_268 = { class: 'col-12 col-md-4 businessClient-data-mobile-row' }
const _hoisted_269 = { class: "field-title" }
const _hoisted_270 = { key: 0 }
const _hoisted_271 = { key: 1 }
const _hoisted_272 = { class: "field-value" }
const _hoisted_273 = { class: "row" }
const _hoisted_274 = {
  key: 0,
  class: "col-12 col-md-4 businessClient-data-mobile-row order-1"
}
const _hoisted_275 = { class: "field-title" }
const _hoisted_276 = { key: 0 }
const _hoisted_277 = { key: 1 }
const _hoisted_278 = { class: "field-value" }
const _hoisted_279 = {
  key: 1,
  class: "col-12 col-md-4 businessClient-data-mobile-row order-2"
}
const _hoisted_280 = { class: "field-title" }
const _hoisted_281 = { class: "p-relative" }
const _hoisted_282 = {
  key: 2,
  class: "col-12 col-md-4 businessClient-data-mobile-row order-3"
}
const _hoisted_283 = { class: "field-title" }
const _hoisted_284 = { key: 0 }
const _hoisted_285 = { key: 1 }
const _hoisted_286 = { class: "field-value" }
const _hoisted_287 = {
  key: 3,
  class: "col-12 col-md-4 businessClient-data-mobile-row order-3"
}
const _hoisted_288 = { class: "field-title" }
const _hoisted_289 = { key: 0 }
const _hoisted_290 = { key: 1 }
const _hoisted_291 = { class: "field-value" }
const _hoisted_292 = {
  key: 4,
  class: "col-12 col-md-8 order-5 order-md-4"
}
const _hoisted_293 = { class: "field-title" }
const _hoisted_294 = { key: 0 }
const _hoisted_295 = { class: "input-text-length" }
const _hoisted_296 = /*#__PURE__*/_createTextVNode("/1000 ")
const _hoisted_297 = { key: 1 }
const _hoisted_298 = { class: "field-value" }
const _hoisted_299 = {
  key: 5,
  class: "col-12 col-md-4 businessClient-data-mobile-row order-4 order-md-5"
}
const _hoisted_300 = { class: "field-title" }
const _hoisted_301 = { key: 0 }
const _hoisted_302 = {
  key: 1,
  class: "truncate"
}
const _hoisted_303 = { class: "field-value" }
const _hoisted_304 = /*#__PURE__*/_createVNode("div", { class: "page-delimiter" }, null, -1)
const _hoisted_305 = { class: "add-photo-row" }
const _hoisted_306 = { class: "field-title" }
const _hoisted_307 = { key: 0 }
const _hoisted_308 = { class: "photo-edit-section" }
const _hoisted_309 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_310 = {
  key: 0,
  class: "cropper-wrapper d-flex pt-3"
}
const _hoisted_311 = {
  key: 1,
  class: "row"
}
const _hoisted_312 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_313 = { class: "row" }
const _hoisted_314 = { class: "col-lg-6 col-12" }
const _hoisted_315 = { class: "col-lg-6 col-12" }
const _hoisted_316 = {
  key: 0,
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_317 = { class: "col-12 ignore-padding" }
const _hoisted_318 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_319 = { class: "photo-wrapper photoInstruction-wrapper" }
const _hoisted_320 = {
  key: 0,
  style: {"top":"0!important"},
  class: "dark-squared"
}
const _hoisted_321 = /*#__PURE__*/_createVNode("div", { class: "page-delimiter" }, null, -1)
const _hoisted_322 = {
  key: 1,
  class: "add-photo-row"
}
const _hoisted_323 = { class: "field-title" }
const _hoisted_324 = { key: 0 }
const _hoisted_325 = { class: "photo-edit-section" }
const _hoisted_326 = {
  class: "col-10 cropper-wrapper-div",
  style: {"margin":"0 auto"}
}
const _hoisted_327 = {
  key: 0,
  class: "cropper-wrapper d-flex pt-3"
}
const _hoisted_328 = {
  key: 1,
  class: "row"
}
const _hoisted_329 = {
  class: "col-5",
  style: {"margin":"0 auto"}
}
const _hoisted_330 = { class: "row" }
const _hoisted_331 = { class: "col-lg-6 col-12" }
const _hoisted_332 = { class: "col-lg-6 col-12" }
const _hoisted_333 = {
  key: 2,
  style: {"margin":"0"}
}
const _hoisted_334 = { style: {"padding-bottom":"12px"} }
const _hoisted_335 = { class: "field-title" }
const _hoisted_336 = { style: {"display":"flex","grid-column-gap":"15px"} }
const _hoisted_337 = { class: "photo-wrapper companyLogo-wrapper" }
const _hoisted_338 = { key: 0 }
const _hoisted_339 = /*#__PURE__*/_createVNode("i", {
  class: "icon-f icon-pencil-edit fs-16",
  "data-v-099e29f6": ""
}, null, -1)
const _hoisted_340 = { class: "" }
const _hoisted_341 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")
  const _component_cropper = _resolveComponent("cropper")
  const _component_BusinessClientAccounting = _resolveComponent("BusinessClientAccounting")
  const _component_BusinessClientOrderProducts = _resolveComponent("BusinessClientOrderProducts")
  const _component_BusinessClientCoupons = _resolveComponent("BusinessClientCoupons")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.isNew)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(1))),
              class: { 'active-btn': _ctx.activeBtn == 1 }
            }, _toDisplayString(_ctx.$t('business-client.label.details')), 3)
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(4))),
              class: { 'active-btn': _ctx.activeBtn == 4, 'cursor-no-drop': _ctx.isNew }
            }, _toDisplayString(_ctx.$t('business-client.label.orders-products')), 3)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(3))),
              class: { 'active-btn': _ctx.activeBtn == 3, 'cursor-no-drop': _ctx.isNew }
            }, _toDisplayString(_ctx.$t('business-client.label.accounting')), 3)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePage(2))),
              class: { 'active-btn': _ctx.activeBtn == 2, 'cursor-no-drop': _ctx.isNew }
            }, _toDisplayString(_ctx.$t('business-client.label.order-settings')), 3)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePage(5))),
              class: { 'active-btn': _ctx.activeBtn == 5, 'cursor-no-drop': _ctx.isNew }
            }, _toDisplayString(_ctx.$t('business-client.label.coupons')), 3)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeBtn == 1)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", {
            class: ["container businessClients-container", _ctx.editMode ? 'editMode' : 'viewMode']
          }, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('businessClient.name')), 1)
                  ]),
                  (_ctx.editMode && _ctx.businessClient.id)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        _createVNode("i", {
                          class: "icon-f icon-earth-shape fs-20",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.routeToEdit('businessClientName')))
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "100",
                        required: "",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.businessClient.name = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.businessClient.name,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("span", _hoisted_16, _toDisplayString(_ctx.businessClient.name), 1)
                    ]))
              ]),
              (_ctx.businessClient.id)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: [_ctx.editMode ? 'col-6 col-md-3' : 'col-12 col-md-3', "col-lg-3 ignore-padding client-id-block businessClient-mobile-details-item"]
                  }, [
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('businessClient.id')) + ":", 1),
                    _createVNode("div", null, [
                      _createVNode("span", _hoisted_18, _toDisplayString(_ctx.businessClient.id), 1)
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.businessClient.id)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: [_ctx.editMode ? 'col-6 col-md-3' : 'col-12 col-md-3', "col-lg-3 ignore-padding businessClientActive"]
                  }, [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('product.active')) + ":", 1),
                    _createVNode("div", null, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "checkbox",
                            class: "toggle",
                            checked: _ctx.businessClient.active,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.businessClient.active = $event)),
                            onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateBusinessClient && _ctx.disactivateOrActivateBusinessClient(...args)), ["stop"]))
                          }, null, 8, ["checked"])), [
                            [_vModelCheckbox, _ctx.businessClient.active]
                          ])
                        : (_openBlock(), _createBlock("div", _hoisted_20, [
                            (_ctx.businessClient.active)
                              ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.$t('product.active')), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_22, _toDisplayString(_ctx.$t('product.notActive')), 1))
                          ]))
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('businessClient.accounting-system-code')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.businessClient.accountingSystemCode = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.businessClient.accountingSystemCode,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_27, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.businessClient.accountingSystemCode), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('businessClient.business-client-type')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_31, [
                      _createVNode(_component_Multiselect, {
                        class: { 'form-controll-multiselect': !_ctx.businessClient.businessClientTypeId },
                        label: "text",
                        modelValue: _ctx.businessClient.businessClientTypeId,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.businessClient.businessClientTypeId = $event)),
                        options: _ctx.businessClientTypesTranslations,
                        canDeselect: false,
                        valueProp: "id",
                        required: "",
                        searchable: false
                      }, null, 8, ["class", "modelValue", "options"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_32, [
                      _createVNode("span", _hoisted_33, _toDisplayString(_ctx.businessClient.businessClientTypeName), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('businessClient.official-club')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_36, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: _ctx.businessClient.officialClubId,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.businessClient.officialClubId = $event)),
                        options: _ctx.officialClubs,
                        canDeselect: false,
                        valueProp: "id",
                        searchable: false
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_37, [
                      _createVNode("span", _hoisted_38, _toDisplayString(_ctx.businessClient.officialClubId && _ctx.officialClubs.find((x)=>x.id == _ctx.businessClient.officialClubId)?.name), 1)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('label.address')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.businessClient.address = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.businessClient.address,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_43, [
                      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.businessClient.address), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('businessClient.country')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_47, [
                      _createVNode(_component_Multiselect, {
                        class: { 'form-controll-multiselect': !_ctx.businessClient.countryId },
                        label: "name",
                        modelValue: _ctx.businessClient.countryId,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.businessClient.countryId = $event)),
                        options: _ctx.countries,
                        canDeselect: false,
                        valueProp: "id",
                        required: "",
                        searchable: false
                      }, null, 8, ["class", "modelValue", "options"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_48, [
                      _createVNode("span", _hoisted_49, _toDisplayString(_ctx.businessClient.countryName), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_50, [
                _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('title.city')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_52, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: _ctx.businessClient.cityId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.businessClient.cityId = $event)),
                        options: _ctx.cities,
                        canDeselect: false,
                        valueProp: "id",
                        trackBy: "name",
                        searchable: true
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_53, [
                      _createVNode("span", _hoisted_54, _toDisplayString(_ctx.businessClient.cityName), 1)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('label.email')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_58, [
                      _withDirectives(_createVNode("input", {
                        class: [{ invalid: _ctx.hasErrorsClientDetails('email') }, "bookit-input product-input form-control h40"],
                        type: "text",
                        maxlength: "255",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.businessClient.email = $event))
                      }, null, 2), [
                        [_vModelText, _ctx.businessClient.email]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_59, [
                      _createVNode("span", _hoisted_60, _toDisplayString(_ctx.businessClient.email), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, _toDisplayString(_ctx.$t('title.phone1')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_63, [
                      _withDirectives(_createVNode("input", {
                        class: [{ invalid: _ctx.hasErrorsClientDetails('phone1') }, "bookit-input product-input form-control h40"],
                        type: "text",
                        maxlength: "20",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.businessClient.phone1 = $event))
                      }, null, 2), [
                        [_vModelText, _ctx.businessClient.phone1]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_64, [
                      _createVNode("span", _hoisted_65, _toDisplayString(_ctx.businessClient.phone1), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_66, [
                _createVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('title.phone2')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_68, [
                      _withDirectives(_createVNode("input", {
                        class: [{ invalid: _ctx.hasErrorsClientDetails('phone2') }, "bookit-input product-input form-control h40"],
                        type: "text",
                        maxlength: "20",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.businessClient.phone2 = $event))
                      }, null, 2), [
                        [_vModelText, _ctx.businessClient.phone2]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_69, [
                      _createVNode("span", _hoisted_70, _toDisplayString(_ctx.businessClient.phone2), 1)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, [
                _createVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('label.fax')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_74, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.businessClient.fax = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.businessClient.fax]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_75, [
                      _createVNode("span", _hoisted_76, _toDisplayString(_ctx.businessClient.fax), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_77, [
                _createVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('label.website')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.businessClient.website = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.businessClient.website]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_80, [
                      _createVNode("span", _hoisted_81, _toDisplayString(_ctx.businessClient.website), 1)
                    ]))
              ]),
              _createVNode("div", _hoisted_82, [
                _createVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('label.vatNumber')), 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_84, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        maxlength: "40",
                        class: "bookit-input product-input form-control h40",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.businessClient.vatNumber = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.businessClient.vatNumber]
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_85, [
                      _createVNode("span", _hoisted_86, _toDisplayString(_ctx.businessClient.vatNumber), 1)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_87, [
              _createVNode("div", _hoisted_88, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_89, [
                      _createVNode(_component_CheckBoxInput, {
                        class: "receive-email-check-box",
                        modelValue: _ctx.businessClient.isSubsidized,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.businessClient.isSubsidized = $event)),
                        singleLine: true
                      }, null, 8, ["modelValue"]),
                      _createVNode("div", _hoisted_90, _toDisplayString(_ctx.$t('businessClient.is-subsidized')), 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_91, [
                      _createVNode("div", _hoisted_92, _toDisplayString(_ctx.$t('businessClient.is-subsidized')), 1),
                      _createVNode("div", _hoisted_93, _toDisplayString(_ctx.businessClient.isSubsidized ? _ctx.$t('label.yes') : _ctx.$t('label.no')), 1)
                    ]))
              ])
            ]),
            (!_ctx.editMode)
              ? (_openBlock(), _createBlock("div", _hoisted_94, [
                  _createVNode("div", _hoisted_95, [
                    _createVNode("div", _hoisted_96, _toDisplayString(_ctx.$t('product.active')), 1),
                    _createVNode("div", null, [
                      (_ctx.businessClient.active)
                        ? (_openBlock(), _createBlock("p", _hoisted_97, _toDisplayString(_ctx.$t('product.active')), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_98, _toDisplayString(_ctx.$t('product.notActive')), 1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.editMode && _ctx.businessClient.businessClientContacts.length)
              ? (_openBlock(), _createBlock("div", _hoisted_99))
              : _createCommentVNode("", true),
            (_ctx.editMode && _ctx.businessClient.businessClientContacts.length < 30)
              ? (_openBlock(), _createBlock("div", _hoisted_100, [
                  _createVNode("button", {
                    class: "btn browse-photo green-button",
                    type: "button",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addBusinessClientContact && _ctx.addBusinessClientContact(...args)))
                  }, [
                    _hoisted_101,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('businessClient.addContact')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClient.businessClientContacts, (contact, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "contact-item"
              }, [
                _createVNode("div", _hoisted_102, [
                  _createVNode("div", {
                    class: [{ 'ignore-padding': index == 0 && !_ctx.editMode }, "col-12 contact-title"]
                  }, _toDisplayString(_ctx.$t('businessClient.contact-title')) + " " + _toDisplayString(index + 1), 3),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: "icon-f icon-delete-cross fs-16 deleteContact",
                        onClick: ($event: any) => (_ctx.deleteContact(index))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_103, [
                  _createVNode("div", _hoisted_104, [
                    _createVNode("div", _hoisted_105, _toDisplayString(_ctx.$t('businessClient.firstName')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_106, [
                          _withDirectives(_createVNode("input", {
                            class: [{ invalid: _ctx.hasContactError(index, 'firstName') }, "bookit-input product-input form-control h40"],
                            required: "",
                            type: "text",
                            maxlength: "50",
                            "onUpdate:modelValue": ($event: any) => (contact.firstName = $event)
                          }, null, 10, ["onUpdate:modelValue"]), [
                            [
                              _vModelText,
                              contact.firstName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.hasContactError(index, 'firstName') && _ctx.contactsHasDuplicates)
                            ? (_openBlock(), _createBlock("span", _hoisted_107, [
                                _hoisted_108,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isDuplicate')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_109, [
                          _createVNode("span", _hoisted_110, _toDisplayString(contact.firstName), 1)
                        ]))
                  ]),
                  _createVNode("div", _hoisted_111, [
                    _createVNode("div", _hoisted_112, _toDisplayString(_ctx.$t('businessClient.lastName')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_113, [
                          _withDirectives(_createVNode("input", {
                            class: [{ invalid: _ctx.hasContactError(index, 'lastName') }, "bookit-input product-input form-control h40"],
                            type: "text",
                            maxlength: "50",
                            "onUpdate:modelValue": ($event: any) => (contact.lastName = $event)
                          }, null, 10, ["onUpdate:modelValue"]), [
                            [
                              _vModelText,
                              contact.lastName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.hasContactError(index, 'lastName') && _ctx.contactsHasDuplicates)
                            ? (_openBlock(), _createBlock("span", _hoisted_114, [
                                _hoisted_115,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isDuplicate')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_116, [
                          _createVNode("span", _hoisted_117, _toDisplayString(contact.lastName), 1)
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_118, [
                  _createVNode("div", _hoisted_119, [
                    _createVNode("div", _hoisted_120, _toDisplayString(_ctx.$t('label.mobile')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_121, [
                          _withDirectives(_createVNode("input", {
                            class: [{ invalid: _ctx.hasContactError(index, 'mobile') }, "bookit-input product-input form-control h40"],
                            type: "text",
                            maxlength: "255",
                            "onUpdate:modelValue": ($event: any) => (contact.mobile = $event),
                            onInput: () => (contact.mobile = contact.mobile.replace(/[^\s+\-0-9]/g, ''))
                          }, null, 42, ["onUpdate:modelValue", "onInput"]), [
                            [
                              _vModelText,
                              contact.mobile,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.hasContactError(index, 'mobile') && _ctx.contactsHasDuplicates)
                            ? (_openBlock(), _createBlock("span", _hoisted_122, [
                                _hoisted_123,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isDuplicate')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_124, [
                          _createVNode("span", _hoisted_125, _toDisplayString(contact.mobile), 1)
                        ]))
                  ]),
                  _createVNode("div", _hoisted_126, [
                    _createVNode("div", _hoisted_127, _toDisplayString(_ctx.$t('businessClient.office-phone')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_128, [
                          _withDirectives(_createVNode("input", {
                            class: [{ invalid: _ctx.hasContactError(index, 'officePhone') }, "bookit-input product-input form-control h40"],
                            type: "text",
                            maxlength: "255",
                            "onUpdate:modelValue": ($event: any) => (contact.phone = $event),
                            onInput: () => (contact.phone = contact.phone.replace(/[^\s+\-0-9]/g, ''))
                          }, null, 42, ["onUpdate:modelValue", "onInput"]), [
                            [
                              _vModelText,
                              contact.phone,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.hasContactError(index, 'officePhone') && _ctx.contactsHasDuplicates)
                            ? (_openBlock(), _createBlock("span", _hoisted_129, [
                                _hoisted_130,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isDuplicate')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_131, [
                          _createVNode("span", _hoisted_132, _toDisplayString(contact.phone), 1)
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_133, [
                  _createVNode("div", _hoisted_134, [
                    _createVNode("div", _hoisted_135, _toDisplayString(_ctx.$t('label.email')) + ":", 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_136, [
                          _withDirectives(_createVNode("input", {
                            class: [{ invalid: _ctx.hasContactError(index, 'email') }, "bookit-input product-input form-control h40"],
                            type: "text",
                            maxlength: "255",
                            "onUpdate:modelValue": ($event: any) => (contact.email = $event)
                          }, null, 10, ["onUpdate:modelValue"]), [
                            [
                              _vModelText,
                              contact.email,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.hasContactError(index, 'email') && _ctx.contactsHasDuplicates)
                            ? (_openBlock(), _createBlock("span", _hoisted_137, [
                                _hoisted_138,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isDuplicate')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_139, [
                          _createVNode("span", _hoisted_140, _toDisplayString(contact.email), 1)
                        ]))
                  ]),
                  _createVNode("div", _hoisted_141, [
                    _createVNode("div", _hoisted_142, _toDisplayString(_ctx.$t('businessClient.role')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_143, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "100",
                            class: "bookit-input product-input form-control h40",
                            "onUpdate:modelValue": ($event: any) => (contact.role = $event)
                          }, null, 8, ["onUpdate:modelValue"]), [
                            [
                              _vModelText,
                              contact.role,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_144, [
                          _createVNode("span", _hoisted_145, _toDisplayString(contact.role), 1)
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_146, [
                  _createVNode("div", _hoisted_147, [
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_148, [
                          _createVNode(_component_CheckBoxInput, {
                            class: "receive-email-check-box",
                            modelValue: contact.receiveEmailNotifications,
                            "onUpdate:modelValue": ($event: any) => (contact.receiveEmailNotifications = $event),
                            singleLine: true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode("div", _hoisted_149, _toDisplayString(_ctx.$t('businessClient.receive-email-notifications')), 1)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_150, [
                          _createVNode("div", _hoisted_151, _toDisplayString(_ctx.$t('businessClient.receive-email-notifications')), 1),
                          _createVNode("div", {
                            class: ["field-value", 'contact-resive-email-' + contact.receiveEmailNotifications]
                          }, _toDisplayString(contact.receiveEmailNotifications ? _ctx.$t('label.active') : _ctx.$t('label.notactive')), 3)
                        ]))
                  ])
                ])
              ]))
            }), 128)),
            false
              ? (_openBlock(), _createBlock("div", _hoisted_152, [
                  _createVNode("div", _hoisted_153, [
                    _createVNode("h5", _hoisted_154, [
                      _createVNode("button", _hoisted_155, _toDisplayString(_ctx.$t('businessClient.DiscountCombination')), 1),
                      _hoisted_156
                    ])
                  ]),
                  _createVNode("div", _hoisted_157, [
                    _createVNode("div", _hoisted_158, [
                      _createVNode("div", _hoisted_159, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_160, [
                              _createVNode("span", {
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addDiscountCombination())),
                                class: "icon dark-squared-plus"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClient.businessClientDiscountCombinations, (combination, indexCombination) => {
                          return (_openBlock(), _createBlock("div", {
                            key: indexCombination,
                            class: { 'combination-item': _ctx.editMode }
                          }, [
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_161, [
                                  _createVNode("span", {
                                    class: "icon-f icon-delete-cross fs-16 deleteCombination",
                                    onClick: ($event: any) => (_ctx.deleteCombination(indexCombination))
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_162, [
                              _createVNode("div", _hoisted_163, [
                                _createVNode("div", _hoisted_164, _toDisplayString(_ctx.$t('label.channel')) + ":", 1),
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_165, [
                                      _createVNode(_component_Multiselect, {
                                        class: { 'form-controll-multiselect': !combination.channelId },
                                        label: "text",
                                        modelValue: combination.channelId,
                                        "onUpdate:modelValue": ($event: any) => (combination.channelId = $event),
                                        options: _ctx.channels,
                                        canDeselect: false,
                                        valueProp: "id",
                                        required: "",
                                        searchable: false
                                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options"])
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_166, [
                                      _createVNode("span", _hoisted_167, _toDisplayString(combination.channelName), 1)
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_168, [
                                _createVNode("div", _hoisted_169, _toDisplayString(_ctx.$t('label.price-type')), 1),
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_170, [
                                      _createVNode(_component_Multiselect, {
                                        class: { 'form-controll-multiselect': !combination.priceTypeId },
                                        label: "text",
                                        modelValue: combination.priceTypeId,
                                        "onUpdate:modelValue": ($event: any) => (combination.priceTypeId = $event),
                                        options: _ctx.priceTypes,
                                        canDeselect: false,
                                        valueProp: "id",
                                        required: "",
                                        searchable: false
                                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options"])
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_171, [
                                      _createVNode("span", _hoisted_172, _toDisplayString(combination.priceTypeName), 1)
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_173, [
                                _createVNode("div", _hoisted_174, _toDisplayString(_ctx.$t('label.discount')), 1),
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_175, [
                                      _withDirectives(_createVNode("input", {
                                        min: "0.01",
                                        step: "0.01",
                                        max: "100",
                                        "onUpdate:modelValue": ($event: any) => (combination.discount = $event),
                                        class: "form-control h-auto bookit-input",
                                        type: "number",
                                        required: "",
                                        onKeypress: _cache[25] || (_cache[25] = ($event: any) => (_ctx.filterKeyOnlyNumbersDotComma($event))),
                                        onPaste: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.filterPastedOnlyNumbersDotComma && _ctx.filterPastedOnlyNumbersDotComma(...args))),
                                        onChange: ($event: any) => (_ctx.validateCommission($event, indexCombination))
                                      }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                        [_vModelText, combination.discount]
                                      ])
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_176, [
                                      _createVNode("span", _hoisted_177, _toDisplayString(combination.discount) + "%", 1)
                                    ]))
                              ]),
                              _createVNode("div", _hoisted_178, [
                                _createVNode("div", _hoisted_179, _toDisplayString(_ctx.$t('title.currency')) + ":", 1),
                                (_ctx.editMode)
                                  ? (_openBlock(), _createBlock("div", _hoisted_180, [
                                      _createVNode(_component_Multiselect, {
                                        class: { 'form-controll-multiselect': !combination.currencyId },
                                        label: "symbol",
                                        modelValue: combination.currencyId,
                                        "onUpdate:modelValue": ($event: any) => (combination.currencyId = $event),
                                        options: _ctx.currencies,
                                        canDeselect: false,
                                        valueProp: "id",
                                        required: "",
                                        searchable: false
                                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options"])
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_181, [
                                      _createVNode("span", _hoisted_182, _toDisplayString(combination.currencySymbol), 1)
                                    ]))
                              ])
                            ]),
                            (!_ctx.editMode && indexCombination != _ctx.businessClient.businessClientDiscountCombinations.length - 1)
                              ? (_openBlock(), _createBlock("div", _hoisted_183))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock("div", _hoisted_184, [
                  _createVNode("div", _hoisted_185, [
                    _createVNode("h5", _hoisted_186, [
                      _createVNode("button", _hoisted_187, _toDisplayString(_ctx.$t('businessClient.OrdersSettings')), 1),
                      _hoisted_188
                    ])
                  ]),
                  _createVNode("div", _hoisted_189, [
                    _createVNode("div", _hoisted_190, [
                      _createVNode("div", _hoisted_191, [
                        _createVNode("div", _hoisted_192, [
                          _createVNode("div", {
                            class: _ctx.editMode ? 'col-12 col-md-12' : 'col-12 col-md-6'
                          }, [
                            _createVNode("div", _hoisted_193, _toDisplayString(_ctx.$t('businessClient.searchSystem')) + ":", 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_194, [
                                  _createVNode(_component_Multiselect, {
                                    label: "name",
                                    modelValue: _ctx.businessClient.couponSystem,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.businessClient.couponSystem = $event)),
                                    options: _ctx.businessSearchSystems,
                                    canDeselect: true,
                                    valueProp: "id",
                                    searchable: false
                                  }, null, 8, ["modelValue", "options"])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_195, [
                                  _createVNode("span", _hoisted_196, _toDisplayString(_ctx.businessClient.couponSystem ? _ctx.searchSystem[_ctx.businessClient.couponSystem] : ''), 1)
                                ]))
                          ], 2),
                          _createVNode("div", _hoisted_197, [
                            _createVNode("div", _hoisted_198, _toDisplayString(_ctx.$t('businessClient.searchUsername')), 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_199, [
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    maxlength: "100",
                                    class: "bookit-input product-input form-control h40",
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.businessClient.couponSystemUsername = $event))
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.businessClient.couponSystemUsername,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_200, [
                                  _createVNode("span", _hoisted_201, _toDisplayString(_ctx.businessClient.couponSystemUsername), 1)
                                ]))
                          ]),
                          (_ctx.editMode)
                            ? (_openBlock(), _createBlock("div", _hoisted_202, [
                                _createVNode("div", _hoisted_203, _toDisplayString(_ctx.$t('businessClient.searchPassword')), 1),
                                _createVNode("div", _hoisted_204, [
                                  _withDirectives(_createVNode("input", {
                                    type: _ctx.passwordFieldType,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.businessClient.couponSystemPassword = $event)),
                                    class: "form-control form-control-lg pr-45",
                                    placeholder: "********"
                                  }, null, 8, ["type"]), [
                                    [_vModelDynamic, _ctx.businessClient.couponSystemPassword]
                                  ]),
                                  _createVNode("i", {
                                    class: ["icon-f fs-28 password-eye", _ctx.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.passwordFieldType = _ctx.passwordFieldType === 'password' ? 'text' : 'password'))
                                  }, null, 2)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_205, [
                            _createVNode("div", _hoisted_206, _toDisplayString(_ctx.$t('businessClient.searchUrl')), 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_207, [
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    maxlength: "255",
                                    class: "bookit-input product-input form-control h40",
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.businessClient.couponSystemUrl = $event))
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.businessClient.couponSystemUrl,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_208, [
                                  _createVNode("span", _hoisted_209, _toDisplayString(_ctx.businessClient.couponSystemUrl), 1)
                                ]))
                          ]),
                          _createVNode("div", _hoisted_210, [
                            _createVNode("div", _hoisted_211, _toDisplayString(_ctx.$t('businessClientSetting.coupon-organization-id')), 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_212, [
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    maxlength: "255",
                                    class: "bookit-input product-input form-control h40",
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.businessClient.couponSystemOrganizationId = $event))
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.businessClient.couponSystemOrganizationId,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_213, [
                                  _createVNode("span", _hoisted_214, _toDisplayString(_ctx.businessClient.couponSystemOrganizationId), 1)
                                ]))
                          ]),
                          _createVNode("div", _hoisted_215, [
                            _createVNode("div", _hoisted_216, _toDisplayString(_ctx.$t('businessClient.searchTerminal')), 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_217, [
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    maxlength: "50",
                                    class: "bookit-input product-input form-control h40",
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.businessClient.couponSystemTerminal = $event))
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.businessClient.couponSystemTerminal,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_218, [
                                  _createVNode("span", _hoisted_219, _toDisplayString(_ctx.businessClient.couponSystemTerminal), 1)
                                ]))
                          ]),
                          _createVNode("div", _hoisted_220, [
                            _createVNode("div", _hoisted_221, _toDisplayString(_ctx.$t('businessClient.instruction')), 1),
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_222, [
                                  _withDirectives(_createVNode("textarea", {
                                    name: "textArea",
                                    id: "instruction",
                                    class: "bookit-textarea product-textarea resize-off short-description form-control",
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.businessClient.instruction = $event)),
                                    style: {"max-height":"56px"},
                                    maxlength: "1000"
                                  }, null, 512), [
                                    [_vModelText, _ctx.businessClient.instruction]
                                  ]),
                                  _createVNode("span", _hoisted_223, [
                                    _createVNode("span", {
                                      class: { 'length-limit': (_ctx.businessClient.instruction?.length ?? 0) > 999 }
                                    }, _toDisplayString(_ctx.businessClient.instruction?.length ?? 0), 3),
                                    _hoisted_224
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_225, [
                                  _createVNode("span", _hoisted_226, _toDisplayString(_ctx.businessClient.instruction), 1)
                                ]))
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_227, [
                        _createVNode("div", _hoisted_228, [
                          _createVNode("div", _hoisted_229, _toDisplayString(_ctx.$t('businessClient.photoInstructions')) + ":", 1),
                          (_ctx.editMode && _ctx.businessClient.businessClientPhotoInstructions.length < 2)
                            ? (_openBlock(), _createBlock("div", _hoisted_230, [
                                _createVNode("span", {
                                  style: {"top":"0!important"},
                                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.uploadPhotoInstruction($event, 'client-instruction-upload-input'))),
                                  class: "icon dark-squared-plus"
                                }, [
                                  _createVNode("input", {
                                    type: "file",
                                    name: "",
                                    id: "client-instruction-upload-input",
                                    style: {"display":"none"},
                                    onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.uploadingPhotoInstructionValidation($event))),
                                    accept: "image/*"
                                  }, null, 32)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_231, [
                          _createVNode("div", _hoisted_232, [
                            (_ctx.photoInstructionSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_233, [
                                  _createVNode(_component_cropper, {
                                    ref: "cropperInstructionLib",
                                    class: "cropper",
                                    src: _ctx.photoInstructionSrc,
                                    "stencil-props": {
                                                    aspectRatio: 368 / 170
                                                }
                                  }, null, 8, ["src"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.photoInstructionSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_234, [
                                  _createVNode("div", _hoisted_235, [
                                    _createVNode("div", _hoisted_236, [
                                      _createVNode("div", _hoisted_237, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "btn save-image-btn browse-photo green-button mt-4",
                                          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.savePhotoInstruction && _ctx.savePhotoInstruction(...args)))
                                        }, _toDisplayString(_ctx.$t('button.save')), 1)
                                      ]),
                                      _createVNode("div", _hoisted_238, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "clear-image-btn btn browse-photo gray-button mt-4",
                                          onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.clearPhotoInstruction && _ctx.clearPhotoInstruction(...args)))
                                        }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.businessClient.businessClientPhotoInstructions.length)
                          ? (_openBlock(), _createBlock("div", _hoisted_239, [
                              _createVNode("div", _hoisted_240, [
                                _createVNode("div", _hoisted_241, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClient.businessClientPhotoInstructions, (photoInstruction) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: photoInstruction.id,
                                      class: "photo-container photo-instruction-item"
                                    }, [
                                      _createVNode("div", _hoisted_242, [
                                        _createVNode("img", {
                                          src: photoInstruction.url
                                        }, null, 8, ["src"])
                                      ]),
                                      (_ctx.editMode)
                                        ? (_openBlock(), _createBlock("span", _hoisted_243, [
                                            _createVNode("i", {
                                              class: "deleteCombination fs-16 icon-delete-cross icon-f",
                                              onClick: ($event: any) => (_ctx.deleteInstructionPhoto(photoInstruction.id))
                                            }, null, 8, ["onClick"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_244, [
                        (!_ctx.businessClient.companyLogoUrl)
                          ? (_openBlock(), _createBlock("div", _hoisted_245, [
                              _createVNode("div", _hoisted_246, [
                                _createVNode("p", _hoisted_247, _toDisplayString(_ctx.$t('businessClient.logo')) + ":", 1)
                              ]),
                              (_ctx.editMode)
                                ? (_openBlock(), _createBlock("div", _hoisted_248, [
                                    _createVNode("span", {
                                      style: {"top":"0!important"},
                                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.startUploadImage($event, 'client-company-upload-input'))),
                                      class: "icon dark-squared-plus"
                                    }, [
                                      _createVNode("input", {
                                        type: "file",
                                        name: "",
                                        id: "client-company-upload-input",
                                        style: {"display":"none"},
                                        onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.uploadingCompanyLogoValidation($event))),
                                        accept: "image/*"
                                      }, null, 32)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_249, [
                          _createVNode("div", _hoisted_250, [
                            (_ctx.companyLogoSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_251, [
                                  _createVNode(_component_cropper, {
                                    ref: "cropperLib",
                                    class: "cropper",
                                    src: _ctx.companyLogoSrc,
                                    "stencil-props": {
                                                    aspectRatio: 100 / 120
                                                }
                                  }, null, 8, ["src"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.companyLogoSrc)
                              ? (_openBlock(), _createBlock("div", _hoisted_252, [
                                  _createVNode("div", _hoisted_253, [
                                    _createVNode("div", _hoisted_254, [
                                      _createVNode("div", _hoisted_255, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "btn save-image-btn browse-photo green-button mt-4",
                                          onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.saveCompanyLogo && _ctx.saveCompanyLogo(...args)))
                                        }, _toDisplayString(_ctx.$t('button.save')), 1)
                                      ]),
                                      _createVNode("div", _hoisted_256, [
                                        _createVNode("button", {
                                          type: "button",
                                          class: "clear-image-btn btn browse-photo gray-button mt-4",
                                          onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.clearCompanyLogo && _ctx.clearCompanyLogo(...args)))
                                        }, _toDisplayString(_ctx.$t('button.clear')), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.businessClient.companyLogoUrl)
                          ? (_openBlock(), _createBlock("div", _hoisted_257, [
                              _createVNode("div", _hoisted_258, [
                                _createVNode("p", _hoisted_259, _toDisplayString(_ctx.$t('businessClient.logo')) + ":", 1)
                              ]),
                              _createVNode("div", _hoisted_260, [
                                _createVNode("div", _hoisted_261, [
                                  _createVNode("div", _hoisted_262, [
                                    _createVNode("div", _hoisted_263, [
                                      _createVNode("img", {
                                        src: _ctx.businessClient.companyLogoUrl
                                      }, null, 8, ["src"])
                                    ])
                                  ])
                                ])
                              ]),
                              (_ctx.editMode)
                                ? (_openBlock(), _createBlock("div", _hoisted_264, [
                                    _createVNode("span", {
                                      style: {"top":"0!important"},
                                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.startUploadImage($event, 'client-company-upload-input'))),
                                      class: "dark-squared"
                                    }, [
                                      _hoisted_265,
                                      _createVNode("input", {
                                        type: "file",
                                        name: "",
                                        id: "client-company-upload-input",
                                        style: {"display":"none"},
                                        onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.uploadingCompanyLogoValidation($event))),
                                        accept: "image/*"
                                      }, null, 32)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeBtn == 2)
      ? (_openBlock(), _createBlock("div", _hoisted_266, [
          _createVNode("div", {
            class: ["container businessClients-container businessClient-settings", _ctx.editMode ? 'editMode' : 'viewMode']
          }, [
            _createVNode("div", _hoisted_267, [
              _createVNode("div", _hoisted_268, [
                _createVNode("div", _hoisted_269, _toDisplayString(_ctx.$t('businessClient.searchSystem')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_270, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: _ctx.businessClient.couponSystem,
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.businessClient.couponSystem = $event)),
                        options: _ctx.businessSearchSystems,
                        canDeselect: true,
                        valueProp: "id",
                        searchable: false
                      }, {
                        clear: _withId(() => [
                          (_ctx.businessClient.couponSystem)
                            ? (_openBlock(), _createBlock("span", {
                                key: 0,
                                onClick: _cache[45] || (_cache[45] = _withModifiers(($event: any) => (_ctx.businessClient.couponSystem = null), ["stop"])),
                                class: "clear-icon"
                              }, "×"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_271, [
                      _createVNode("span", _hoisted_272, _toDisplayString(_ctx.businessClient.couponSystem ? _ctx.searchSystem[_ctx.businessClient.couponSystem] : ''), 1)
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_273, [
              (_ctx.businessClient.couponSystem && _ctx.businessClient.couponSystem == _ctx.searchSystem.Multipass)
                ? (_openBlock(), _createBlock("div", _hoisted_274, [
                    _createVNode("div", _hoisted_275, _toDisplayString(_ctx.$t('businessClient.searchUsername')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_276, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "100",
                            class: "bookit-input product-input form-control h40",
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.businessClient.couponSystemUsername = $event)),
                            autocomplete: "off"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.businessClient.couponSystemUsername,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_277, [
                          _createVNode("span", _hoisted_278, _toDisplayString(_ctx.businessClient.couponSystemUsername), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.businessClient.couponSystem && _ctx.editMode && _ctx.businessClient.couponSystem == _ctx.searchSystem.Multipass)
                ? (_openBlock(), _createBlock("div", _hoisted_279, [
                    _createVNode("div", _hoisted_280, _toDisplayString(_ctx.$t('businessClient.searchPassword')), 1),
                    _createVNode("div", _hoisted_281, [
                      _withDirectives(_createVNode("input", {
                        type: _ctx.passwordFieldType,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.businessClient.couponSystemPassword = $event)),
                        class: "form-control form-control-lg pr-45",
                        placeholder: "********",
                        autocomplete: "off"
                      }, null, 8, ["type"]), [
                        [_vModelDynamic, _ctx.businessClient.couponSystemPassword]
                      ]),
                      _createVNode("i", {
                        class: ["icon-f fs-28 password-eye", _ctx.passwordFieldType === 'password' ? 'icon-eye' : 'icon-eye-hide'],
                        onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.passwordFieldType = _ctx.passwordFieldType === 'password' ? 'text' : 'password'))
                      }, null, 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createBlock("div", _hoisted_282, [
                    _createVNode("div", _hoisted_283, _toDisplayString(_ctx.$t('businessClient.searchUrl')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_284, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "255",
                            class: "bookit-input product-input form-control h40",
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.businessClient.couponSystemUrl = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.businessClient.couponSystemUrl,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_285, [
                          _createVNode("span", _hoisted_286, _toDisplayString(_ctx.businessClient.couponSystemUrl), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.businessClient.couponSystem && _ctx.businessClient.couponSystem == _ctx.searchSystem.Multipass)
                ? (_openBlock(), _createBlock("div", _hoisted_287, [
                    _createVNode("div", _hoisted_288, _toDisplayString(_ctx.$t('businessClientSetting.coupon-organization-id')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_289, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "255",
                            class: "bookit-input product-input form-control h40",
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.businessClient.couponSystemOrganizationId = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.businessClient.couponSystemOrganizationId,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_290, [
                          _createVNode("span", _hoisted_291, _toDisplayString(_ctx.businessClient.couponSystemOrganizationId), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.businessClient.couponSystem)
                ? (_openBlock(), _createBlock("div", _hoisted_292, [
                    _createVNode("div", _hoisted_293, _toDisplayString(_ctx.$t('businessClient.instruction')), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_294, [
                          _withDirectives(_createVNode("textarea", {
                            name: "textArea",
                            id: "instruction",
                            class: "bookit-textarea product-textarea resize-off short-description form-control",
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.businessClient.instruction = $event)),
                            style: {"max-height":"56px"},
                            maxlength: "1000"
                          }, null, 512), [
                            [_vModelText, _ctx.businessClient.instruction]
                          ]),
                          _createVNode("span", _hoisted_295, [
                            _createVNode("span", {
                              class: { 'length-limit': (_ctx.businessClient.instruction?.length ?? 0) > 999 }
                            }, _toDisplayString(_ctx.businessClient.instruction?.length ?? 0), 3),
                            _hoisted_296
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_297, [
                          _createVNode("span", _hoisted_298, _toDisplayString(_ctx.businessClient.instruction), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.businessClient.couponSystem)
                ? (_openBlock(), _createBlock("div", _hoisted_299, [
                    _createVNode("div", _hoisted_300, _toDisplayString(_ctx.businessClient.couponSystem != _ctx.searchSystem.Tmura ? _ctx.$t('businessClient.searchTerminal') : 'API key'), 1),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_301, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            maxlength: "50",
                            class: "bookit-input product-input form-control h40",
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.businessClient.couponSystemTerminal = $event))
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.businessClient.couponSystemTerminal,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_302, [
                          _createVNode("span", _hoisted_303, _toDisplayString(_ctx.businessClient.couponSystemTerminal), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_304,
            _createVNode("div", _hoisted_305, [
              _createVNode("div", _hoisted_306, _toDisplayString(_ctx.$t('businessClient.photoInstructions')) + ":", 1),
              (_ctx.editMode && _ctx.businessClient.businessClientPhotoInstructions.length < 2)
                ? (_openBlock(), _createBlock("div", _hoisted_307, [
                    _createVNode("span", {
                      style: {"top":"0!important"},
                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.uploadPhotoInstruction($event, 'client-instruction-upload-input'))),
                      class: "icon dark-squared-plus"
                    }, [
                      _createVNode("input", {
                        type: "file",
                        name: "",
                        id: "client-instruction-upload-input",
                        style: {"display":"none"},
                        onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.uploadingPhotoInstructionValidation($event))),
                        accept: "image/*"
                      }, null, 32)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_308, [
              _createVNode("div", _hoisted_309, [
                (_ctx.photoInstructionSrc)
                  ? (_openBlock(), _createBlock("div", _hoisted_310, [
                      _createVNode(_component_cropper, {
                        ref: "cropperInstructionLib",
                        class: "cropper",
                        src: _ctx.photoInstructionSrc,
                        "stencil-props": {
                                    aspectRatio: 368 / 170
                                }
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.photoInstructionSrc)
                  ? (_openBlock(), _createBlock("div", _hoisted_311, [
                      _createVNode("div", _hoisted_312, [
                        _createVNode("div", _hoisted_313, [
                          _createVNode("div", _hoisted_314, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn save-image-btn browse-photo green-button mt-4",
                              onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.savePhotoInstruction && _ctx.savePhotoInstruction(...args)))
                            }, _toDisplayString(_ctx.$t('button.save')), 1)
                          ]),
                          _createVNode("div", _hoisted_315, [
                            _createVNode("button", {
                              type: "button",
                              class: "clear-image-btn btn browse-photo gray-button mt-4",
                              onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.clearPhotoInstruction && _ctx.clearPhotoInstruction(...args)))
                            }, _toDisplayString(_ctx.$t('button.clear')), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.businessClient.businessClientPhotoInstructions.length)
              ? (_openBlock(), _createBlock("div", _hoisted_316, [
                  _createVNode("div", _hoisted_317, [
                    _createVNode("div", _hoisted_318, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessClient.businessClientPhotoInstructions, (photoInstruction) => {
                        return (_openBlock(), _createBlock("div", {
                          key: photoInstruction.id,
                          class: "photo-container photo-instruction-item"
                        }, [
                          _createVNode("div", _hoisted_319, [
                            _createVNode("img", {
                              src: photoInstruction.url
                            }, null, 8, ["src"])
                          ]),
                          (_ctx.editMode)
                            ? (_openBlock(), _createBlock("span", _hoisted_320, [
                                _createVNode("i", {
                                  class: "deleteCombination fs-16 icon-delete-cross icon-f",
                                  onClick: ($event: any) => (_ctx.deleteInstructionPhoto(photoInstruction.id))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_321,
            (!_ctx.businessClient.companyLogoUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_322, [
                  _createVNode("div", _hoisted_323, _toDisplayString(_ctx.$t('businessClient.logo')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_324, [
                        _createVNode("span", {
                          style: {"top":"0!important"},
                          onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.startUploadImage($event, 'client-company-upload-input'))),
                          class: "icon dark-squared-plus"
                        }, [
                          _createVNode("input", {
                            type: "file",
                            name: "",
                            id: "client-company-upload-input",
                            style: {"display":"none"},
                            onChange: _cache[58] || (_cache[58] = ($event: any) => (_ctx.uploadingCompanyLogoValidation($event))),
                            accept: "image/*"
                          }, null, 32)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_325, [
              _createVNode("div", _hoisted_326, [
                (_ctx.companyLogoSrc)
                  ? (_openBlock(), _createBlock("div", _hoisted_327, [
                      _createVNode(_component_cropper, {
                        ref: "cropperLib",
                        class: "cropper",
                        src: _ctx.companyLogoSrc,
                        "stencil-props": {
                                    aspectRatio: 100 / 120
                                }
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.companyLogoSrc)
                  ? (_openBlock(), _createBlock("div", _hoisted_328, [
                      _createVNode("div", _hoisted_329, [
                        _createVNode("div", _hoisted_330, [
                          _createVNode("div", _hoisted_331, [
                            _createVNode("button", {
                              type: "button",
                              class: "btn save-image-btn browse-photo green-button mt-4",
                              onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.saveCompanyLogo && _ctx.saveCompanyLogo(...args)))
                            }, _toDisplayString(_ctx.$t('button.save')), 1)
                          ]),
                          _createVNode("div", _hoisted_332, [
                            _createVNode("button", {
                              type: "button",
                              class: "clear-image-btn btn browse-photo gray-button mt-4",
                              onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.clearCompanyLogo && _ctx.clearCompanyLogo(...args)))
                            }, _toDisplayString(_ctx.$t('button.clear')), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.businessClient.companyLogoUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_333, [
                  _createVNode("div", _hoisted_334, [
                    _createVNode("p", _hoisted_335, _toDisplayString(_ctx.$t('businessClient.logo')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_336, [
                    _createVNode("div", _hoisted_337, [
                      _createVNode("img", {
                        src: _ctx.businessClient.companyLogoUrl
                      }, null, 8, ["src"])
                    ]),
                    (_ctx.editMode)
                      ? (_openBlock(), _createBlock("div", _hoisted_338, [
                          _createVNode("span", {
                            style: {"top":"0!important"},
                            onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.startUploadImage($event, 'client-company-upload-input'))),
                            class: "dark-squared"
                          }, [
                            _hoisted_339,
                            _createVNode("input", {
                              type: "file",
                              name: "",
                              id: "client-company-upload-input",
                              style: {"display":"none"},
                              onChange: _cache[62] || (_cache[62] = ($event: any) => (_ctx.uploadingCompanyLogoValidation($event))),
                              accept: "image/*"
                            }, null, 32)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_340, [
      (!_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_BusinessClientAccounting, {
            key: 0,
            businessClientId: _ctx.businessClient.id,
            selectedPage: _ctx.activeBtn == 3
          }, null, 8, ["businessClientId", "selectedPage"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.activeBtn == 3]
    ]),
    _withDirectives(_createVNode("div", _hoisted_341, [
      (!_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_BusinessClientOrderProducts, {
            key: 0,
            businessClientId: _ctx.businessClient.id,
            selectedPage: _ctx.activeBtn == 4
          }, null, 8, ["businessClientId", "selectedPage"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.activeBtn == 4]
    ]),
    _withDirectives(_createVNode("div", null, [
      (!_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_BusinessClientCoupons, {
            key: 0,
            businessClientId: _ctx.businessClient.id,
            selectedPage: _ctx.activeBtn == 5
          }, null, 8, ["businessClientId", "selectedPage"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.activeBtn == 5]
    ])
  ]))
})